const { axios } = require("@/utils/request");

// 旗下医院列表
export const HospitalList =(params)=>axios.get('/jeecg-system/frontend/qixiaHospital/list_all',{params})